import { useAuthStore } from "../../stores/auth.store";
import User from "../../types/User";

export const useLogin = () => {
	const login = useAuthStore((state) => state.login);

	return (token: string, user: User) => {
		login(token, user);
	};
};
